<template>
  <v-list-item v-bind="$attrs">
    <slot />
  </v-list-item>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { VListItem } from "vuetify/components"

  export default defineComponent({
    components: { VListItem },
    inheritAttrs: false,
  })
</script>
